export default __webpack_public_path__ + "static/media/arrow-neutral-small-white.a1257288.svg";